// Package Imports
import { Card, DatePicker, Modal, Radio } from 'antd';
import { useNavigation, useTranslate, useUpdate } from '@refinedev/core';
// Project Imports
import RulesForm from 'pages/rules/RulesForm';
import CustomModal from 'components/modal/modal';
import { useRulesCreateState } from 'pages/rules/context/RulesCreateStateContext';
// import { EditOutlined } from '@ant-design/icons';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import { useWatch } from 'antd/es/form/Form';
import saveRule from 'pages/rules/utils/saveRule';
import { useRulesContext } from 'contexts/rulesContext/RulesContext';
import resourceName from 'core/common/resourceName';
import { EditOutlined } from '@ant-design/icons';

const RuleMainView = ({
  form,
  type,
  onFinishHandler,
  saveButtonProps,
  formProps,
  unifiedListUnfiltered,
  ruleGroupDate,
  ruleType,
  onFinish,
  saveLoading,
  setSaveLoading,
}: any) => {
  const t = useTranslate();
  const state = useRulesCreateState();
  const ruleDate = useWatch('rules_date', {
    form,
    preserve: true,
  });
  const { mutate } = useUpdate();
  const { refetchRuleDetails, setRefetchRuleDetails, rulePlanDataObj } =
    useRulesContext();
  const { list } = useNavigation();

  const disabledDatee: RangePickerProps['disabledDate'] = (current) => {
    const startDate = dayjs(ruleDate?.[0]);
    const endDate = dayjs(ruleDate?.[1]);
    return current && (current.isBefore(startDate) || current.isAfter(endDate));
  };
  const uniqueId = useWatch('unique_id', {
    form,
    preserve: true,
  });
  const hideModal = (val) => {
    if (val === 'Yes') {
      list(resourceName.rulePlans);
    }
    state.setOpenModal(false);
  };

  console.log('type page ', type, state.pageType);
  return (
    <>
      <div
        className={`relative ${
          state.pageType === 'Show' ? 'rule-details-view' : ''
        }`}
      >
        <Card>
          <div className="">
            <div className="">
              <RulesForm
                formProps={formProps}
                form={form}
                saveButtonProps={saveButtonProps}
                onFinishHandler={onFinishHandler}
                unifiedListUnfiltered={unifiedListUnfiltered}
                ruleGroupDate={ruleGroupDate}
                ruleType={ruleType}
                saveLoading={saveLoading}
                type={type}
              />
            </div>
            <CustomModal
              openModal={state.openModal}
              hideModal={() => state.setOpenModal(false)}
              title="Note"
              okText="Yes"
              cancelText="No"
              message={t('rules.ruleUnsavedChanges')}
            />
          </div>
        </Card>
        {state.pageType !== 'Edit' && type !== 'Create' && type !== 'Show' ? (
          <EditOutlined
            className="text-primary-500 text-md absolute right-4 top-2 w-10 h-10 flex justify-center items-center border border-solid border-primary-500 rounded-md cursor-pointer"
            onClick={() => state.setPageType('Edit')}
          />
        ) : null}
      </div>
      <Modal
        cancelText="Cancel"
        title="Rule Effective From"
        open={state.newVersionModal}
        okButtonProps={{
          disabled: state.selectedDateOption === 'next' && !state.selectedDate,
          loading: saveLoading,
        }}
        onOk={() =>
          saveRule(
            state.currentValues,
            'true',
            state,
            mutate,
            uniqueId,
            form,
            setRefetchRuleDetails,
            refetchRuleDetails,
            onFinish,
            t,
            rulePlanDataObj,
            setSaveLoading
          )
        }
        onCancel={() => {
          state.setNewVersionModal(false);
          state.setSelectedDateOption('current');
          state.setSelectedDate(null);
        }}
        maskClosable={false}
      >
        <Radio.Group
          onChange={(e) => state.setSelectedDateOption(e.target.value)}
          value={state.selectedDateOption}
        >
          <Radio value="current">Current</Radio>
          <Radio value="next">Next</Radio>
        </Radio.Group>
        {state.selectedDateOption === 'next' ? (
          <DatePicker
            disabledDate={disabledDatee}
            onChange={(date, dateString) => {
              state.setSelectedDate(dateString);
              state.setValidationMsg(false);
            }}
            showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
          />
        ) : null}
        {state.validationMsg ? (
          <p className="text-sm mb-0 m-xs text-danger-500">{`Your Previous version date is ${state?.currentValues?.rule_start_date}. Please select a date/time with minimum of 2 seconds difference`}</p>
        ) : null}
      </Modal>
      <CustomModal
        openModal={state.openModal}
        hideModal={hideModal}
        title="Note"
        okText="Yes"
        cancelText="No"
        message={t('rules.ruleUnsavedChanges')}
      />
    </>
  );
};

export default RuleMainView;
